import { render, staticRenderFns } from "./requiredFieldsGroupEditView.vue?vue&type=template&id=2b4db086&scoped=true&"
import script from "./requiredFieldsGroupEditView.vue?vue&type=script&lang=js&"
export * from "./requiredFieldsGroupEditView.vue?vue&type=script&lang=js&"
import style0 from "./requiredFieldsGroupEditView.vue?vue&type=style&index=0&id=2b4db086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4db086",
  null
  
)

export default component.exports